// extracted by mini-css-extract-plugin
module.exports = {"logo-wrapper":"Logo_logo-wrapper__2Bz7x","logo":"Logo_logo__3gPvi","black":"Logo_black__1b8Ej"};